import {createSvgIcon} from '../create-svg-icon';

export const ViewListIcon = createSvgIcon(
  <path d="M3 5v14h18V5H3zm4 2v2H5V7h2zm-2 6v-2h2v2H5zm0 2h2v2H5v-2zm14 2H9v-2h10v2zm0-4H9v-2h10v2zm0-4H9V7h10v2z" />
, 'ViewListOutlined');
